module.exports = __webpack_public_path__ + "img/jiqiren.a419dd6a.png";